/**
 * Readiness check behind the CMS "Enable AI" toggle.
 *
 * Turning AI on is only meaningful if the analyze server is actually reachable
 * and has a Gemini key — otherwise the operator gets AI buttons that fail on
 * click. The analyze server exits at startup without GEMINI_API_KEY, so a
 * successful response here already proves a key is configured.
 */

import axios from "axios";

const GEMINI_BASE_URL = process.env.REACT_APP_GEMINI_ANALYZE_URL || "";

/**
 * @returns {Promise<{available: boolean, reason?: string}>}
 *   `available` true only when the analyze server answered and reports a key.
 */
export const checkAiAvailable = async () => {
  if (!GEMINI_BASE_URL) {
    return { available: false, reason: "AI server is not configured." };
  }

  try {
    const res = await axios.get(`${GEMINI_BASE_URL}/status`, { timeout: 8000 });
    if (res?.data?.data?.configured) return { available: true };
    return { available: false, reason: "No Gemini API key on the AI server." };
  } catch {
    // Unreachable covers both "not deployed" and "died on a missing key".
    return { available: false, reason: "AI server is unreachable." };
  }
};

export default checkAiAvailable;
